import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { NotificationReceiverService } from '@shared/services';
import { NotifierService } from 'angular-notifier';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private subs = new Subscription();
  
  constructor(private notifierService: NotifierService, private zone: NgZone,
    private notificacionService: NotificationReceiverService) { }
  
  ngOnInit(): void {
    this.subs.add(
      this.notificacionService.sendNotification$.subscribe(notification => {
          if (notification.outsideAngular) {
              this.zone.run(() => {
                  this.notifierService.notify(notification.type, notification.message);
              });

              return;
          }

          this.notifierService.notify(notification.type, notification.message);
      })
  );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
